
import { useRoute, useRouter} from 'vue-router'
import { toRefs, defineComponent, reactive, getCurrentInstance, watch, computed } from 'vue'
import { useStore } from '@/store/index'
import { VueDraggableNext } from 'vue-draggable-next'
import { BrandCat } from '@/enums/brand'
import { InvoiceType } from '@/enums/others'
import { CheckStatus } from '@/enums/product'
import { beforeUpload, upload } from '@/utils/upload'
import { joinParams } from '@/utils/index'
import { Plus } from '@element-plus/icons-vue'

interface ImgItemInt {
    uid: number,
    id: number,
    url: string,
    file_name: string
}

export default defineComponent({
name: 'EditCouponLots',
components: {
    Plus,
    draggable: VueDraggableNext
},

setup () {
    const { proxy } = getCurrentInstance() as any
    const router = useRouter()
    const route = useRoute()
    const store = useStore()

    const state = reactive({
        t:  route.query.t, // 页面展示状态
        check_type: route.query.check_type || '',   // check_type=1时,表示是由商户端审核列表进入
        shop_product_id: route.query.id || '',      // 列表页传递过来的ID
        tab_type: route.query.tab_type || '',       // 商户端列表页传递过来的商品状态（1-待上线，2-已上线）
        formData: {
            shop_product_id:    '', // 商品ID
            admin_name: store.state.user.userInfo.username, // 操作人
            brand_id:           '',     // 品牌ID
            brand_cat_id:       null,   // 品牌品类ID
            sbrand_id:          '',     // 二级品牌ID
            sbrand_name:        '',     // 二级品牌名称
            cat_id:             '',     // 当前商品品类
            is_pre_sale:        0,      // 是否为预售商品
            pre_sale_date:      '',     // 预售日期
            city_ids:           [],     // 开通城市
            title:              '',     // 商品名称
            description:        '',     // 商品介绍
            images:             [],     // 商品图 Url
            content_images:     [],     // 详情图 Url
            image_ids:          [],     // 商品图 IDs
            content_img_ids:    [],     // 商品图 ID
            image_id:           '',     // 列表图 ID：在商品图中选中一个
            invoice_type:       '',     // 发票类型
            tax_Point:          null,   // 税点
            tagIdList:          [],     // 某品类下的标签组合：蛋糕包含，蛋糕分类、蛋糕口味等；零食包含,零食分类、零食价格等；鲜花包含，鲜花分类等
            specs:              [],     // 规格
            charges:            [],     // 收费附件
            extra_data: {   // 蛋糕额外配置项
                material:       '',     // 原料
                taste:          '',     // 口感
                sweetness:      '',     // 甜度
                storage:        '',     // 储存条件
                package:        '',     // 包装
                distribution:   ''      // 配送范围
            },
            is_greeting:        0,      // 是否支持配置祝福语
            label_name:         [],     // 商品标签
            is_time:            0,      // 是否定时上架
            examine_time:       null || '',   // 定时上架时间
        },
        hour:                   '',     // 当前选中时间
        brandList:              [],     // 品牌列表
        secondBrandList:        [],     // 二级品牌列表
        cityList:               [],     // 城市列表
        cityIds:                [],     // 全部城市ID集合
        cityListLen:            0,      // 全部城市列表长度
        isSelectedAll:          false,  // 城市全选状态
        isIndeterminate:        false,  // 城市全选中间状态
        tagList:                [],     // 商品标签列表
        specDialog:             false,  // 规格编辑弹框
        chargeDialog:           false,  // 收费附件编辑弹框
        rejectDialog:           false,  // 驳回弹框
        reject_reason:          '',     // 驳回原因
        currSpecIndex:          -1,     // 当前编辑规格索引值
        specOptions: {      // 添加规格所需参数
            id:                 '',     // 规格ID
            name:               '',     // 规格名称
            description:        '',     // 规格描述
            tastes:             '',     // 口味或颜色
            market_price:       '',     // 市场价
            price:              '',     // 售价
            stock:              '',     // 库存
            clearing_price:     '',     // 结算价
            gift:               '',     // 默认赠品
            sku:                '',     // SKU
            shop_discount:      '',     // 规格折扣
            deleted:            '',     // 是否隐藏  
        },
        currChargeIndex:        -1,     // 当前编辑收费附件索引值
        chargeOptions: {    // 添加收费附件所需参数
            id:                 '',     // 附件ID
            name:               '',     // 附件名称
            unity:              '',     // 单位
            price:              '',     // 单价
            limit:              '',     // 限购数
            status:             '',     // 是否隐藏
        },
        imgPreviewList:         [],     // 商品图预览列表
        contentImgPreviewList:  [],     // 详情图预览列表

        imageUrl:'',
        is_check:0,
        product_id:'',

        /**
         * 商户端：保存、提交
         * type：2-保存，3-提交
        */
        submitForm: (type:number) => {
            proxy.$refs['productForm'].validate((valid:boolean) => {
                if (valid) {
                    const { shop_product_id, formData, hour, check_type } = state
                    if (!formData.image_id) { return proxy.$message({ type: 'error', message: '请选择列表图' }) }
                    let tmpFormData = { ...formData, check_type }
                    // @ts-ignore
                    tmpFormData.shop_product_id = shop_product_id
                    tmpFormData.examine_time = tmpFormData.examine_time ? `${tmpFormData.examine_time} ${hour || hourList[0]}` : ''
                    proxy.$http.post('/admin/shop_product/edit', { ...tmpFormData, type }).then((res:any) => {
                        if(res.code == 200){
                            proxy.$message({ type: 'success', message: '操作成功' })
                            router.go(-1)
                        }else{
                            proxy.$message({type:'error',message:res.msg})
                        }
                    })
                }
            })
        },
        /**
         * 运营审核：1-通过并上架，2-通过并下架，3-驳回
        */
        onCheck: (type:number) => {
            const { shop_product_id, formData, reject_reason, check_type, hour } = state
            const { examine_time } = formData
            if (type === 3 && !reject_reason) {
                return proxy.$message({ type: 'error', message: '请输入驳回原因' })
            }

            let urlArr = [
                '/admin/shop_product/authUpProduct',    // 通过并上架接口
                '/admin/shop_product/authDownProduct',  // 通过并下架接口
                '/admin/shop_product/rejectProduct',    // 驳回接口
            ]
            
            proxy.$http.post(urlArr[type-1], {id:shop_product_id, examine_time: examine_time + ' ' + hour, reject_reason, check_type}).then(res => {
                const { code, msg } = res
                if (code != 200) {
                    return proxy.$message({ type: 'error', message: msg })
                }
                proxy.$message({ type: 'success', message: '审核成功' })
                setTimeout(() => {
                    router.go(-1)
                }, 1000)
            })
        },
        // 当选中品牌发生变化
        onBrandChange: (val:number) => {
            const { brandList } = state
            // @ts-ignore
            state.formData.brand_cat_id = brandList.find(item => item.id === val).cat_id // 重新定义当前品牌品类
            state.formData.cat_id       = ''    // 将当前商品品类值设置为默认值
            state.formData.city_ids     = []    // 将开通城市清空
        },

        // 添加规格
        submitSpec: () => {
            proxy.$refs['addSpecFrom'].validate((valid:boolean) => {
                if (valid) {
                    const { currSpecIndex } = state
                    
                    if (currSpecIndex === -1) {   // 新增
                        //@ts-ignore
                        state.formData.specs.push(state.specOptions);
                    } else {    // 编辑
                        //@ts-ignore
                        state.formData.specs[currSpecIndex] = state.specOptions
                        state.currSpecIndex = -1
                    }
                    state.specOptions = {
                        id:'',
                        name:'',
                        description:'',
                        deleted:'',
                        market_price:'',
                        sku:'',
                        price:'',
                        stock:'',
                        clearing_price:'',
                        gift:'',
                        tastes:'',
                        shop_discount:''
                    };
                    state.specDialog = false;
                }
            })
        },
        // 打开规格表单
        showAddSpec:()=>{
            state.specDialog = true;
            state.specOptions.name = '';
            state.specOptions.description = '';
            state.specOptions.deleted = '';
            state.specOptions.market_price = '';
            state.specOptions.sku = '';
            state.specOptions.clearing_price = '';
            state.specOptions.stock = '';
            state.specOptions.gift = '';
            state.specOptions.tastes = '';
            state.specOptions.shop_discount = '';
        },
        // 删除一条规格
        delSpec:(index:number)=>{
            state.formData.specs.splice(index,1);
        },
        // 收费附件
        showAddCharge:()=>{
            state.chargeDialog = true;
            state.chargeOptions.name = '';
            state.chargeOptions.unity = '';
            state.chargeOptions.price = '';
            state.chargeOptions.limit = '';
            state.chargeOptions.status = '';
        },
        // 删除一条收费附件
        delCharge:(index:number)=>{
            state.formData.charges.splice(index,1);
        },
        // 收费附件提交
        submitCharge:()=>{
            proxy.$refs['addChargeFrom'].validate((valid:boolean) => {
                if (valid) {
                    const { currChargeIndex } = state
                    
                    if (currChargeIndex === -1) {   // 新增
                        //@ts-ignore
                        state.formData.charges.push(state.chargeOptions);
                    } else {    // 编辑
                        //@ts-ignore
                        state.formData.charges[currChargeIndex] = state.chargeOptions
                        state.currChargeIndex = -1
                    }
                    state.chargeOptions = {
                        id:'',
                        name:'',
                        unity:'',
                        price:'',
                        limit:'',
                        status:''
                    }
                    state.chargeDialog = false;
                }
            })
        },
        /**
         * 删除图片
         * t：1-商品图，2-详情图
        */
        onImgRemove: (index:number, t:number) => {
            proxy.$confirm('确定要删除该图片？', '提示', {
                type: 'warning',
            }).then(() => {
                if (t === 1) {
                    const { formData, imgPreviewList } = state
                    const { image_ids, images, image_id } = formData
                    const currImgId = image_ids[index]

                    if (currImgId == image_id) { // 如果当前要删除的图片ID与商品列表图ID一致，将商品列表图字段清空
                        state.formData.image_id = ''
                    }

                    image_ids.splice(index, 1)
                    images.splice(index, 1)
                    imgPreviewList.splice(index, 1)

                    state.formData.image_ids = image_ids
                    state.formData.images = images
                    state.imgPreviewList = imgPreviewList
                } else {
                    const { formData, contentImgPreviewList } = state
                    const { content_img_ids, content_images } = formData

                    content_img_ids.splice(index, 1)
                    content_images.splice(index, 1)
                    contentImgPreviewList.splice(index, 1)

                    state.formData.content_img_ids = content_img_ids
                    state.formData.content_images = content_images
                    state.contentImgPreviewList = contentImgPreviewList
                }
            }).catch(() => {
                console.log('取消删除')
            })
        },
        //获取品牌列表
        getBrandList:()=>{
            proxy.$http.post(`/admin/shop_product/getBrandList`).then((res:any) => {
                state.brandList = res.data
            })
        },
        //获取商品信息
        getProductInfo: () => {
            const { shop_product_id, check_type, tab_type } = state
            if (shop_product_id) {
                let params = joinParams({shop_product_id, check_type})
                if (tab_type == '2') {
                    params = joinParams({shop_product_id, check_type, product_id:shop_product_id})
                }
                proxy.$http.post(`/admin/shop_product/getProductInfo?${params}`).then((res) => {
                    const { code, data, msg } = res
                    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

                    if(data.extra_data == null){
                        data.extra_data={
                            'material':'',
                            'taste':'',
                            'sweetness':'',
                            'storage':'',
                            'package':'',
                            'distribution':''
                        };
                    }
                    if (data.dingshi_time) {
                        const timeArr = data.dingshi_time.split(' ')
                        data.examine_time = timeArr[0]
                        state.hour = timeArr[1]
                    }
                    data.sbrand_id = data.sbrand_id || '' // 重置二级品牌默认值
                    data.invoice_type = data.invoice_type || '' // 重置发票类型默认值
                    data.tax_Point = data.tax_Point || null // 重置税点默认值
                    state.formData = data

                    // 商品图和详情图预览列表数据
                    // state.imgPreviewList = data.images.map(item => item.url)
                    state.contentImgPreviewList = data.content_images.map(item => (item.url.replace('?x-oss-process=style/s_img_160', '')).replace('_s.jpg', '.jpg'))
                })
            }
        },
        // 图片排序
        onImgMoveEnd: (e:any) => {
            let { newIndex, oldIndex } = e
            let { image_ids } = state.formData
            let image_id = image_ids[oldIndex]
            image_ids.splice(oldIndex, 1)
            image_ids.splice(newIndex, 0, image_id)
        },
        // 详情图排序
        onContentImgMoveEnd: (e:any) => {
            let { newIndex, oldIndex } = e
            let { content_img_ids } = state.formData
            let content_img_id = content_img_ids[oldIndex]
            content_img_ids.splice(oldIndex, 1)
            content_img_ids.splice(newIndex, 0, content_img_id)
        },
        // 商品主图上传前校验
        onBeforeUpload: (file) => {
            return beforeUpload(file, {size:1024, width:800, height:800})
        },
        // 商品详情图上传前校验
        onContentBeforeUpload: (file) => {
            return beforeUpload(file, {size:1024, width:750})
        },
        // 商品图片上传事件
        onImgUpload: (param) => {
            // @ts-ignore
            state.formData.images.push({uid: param.file.uid})
            state.uploadRequest(param, 1)
        },
        // 商品详情图片上传事件
        onContentImgUpload: (param) => {
            // @ts-ignore
            state.formData.content_images.push({uid: param.file.uid})
            state.uploadRequest(param, 2)
        },
        // 自定义图片上传方法
        uploadRequest: async (param, type) => {
            const res:any = await upload(param.file, {folderName: 'product'})
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            const { uid, img_info } = data
            const { id, o_path:url, file_name } = img_info
            let item = { id, url, file_name }
            if (type === 1) {
                let fitItemIndex = state.formData.images.findIndex((item:ImgItemInt) => item.uid == uid)
                // @ts-ignore
                state.formData.images[fitItemIndex] = { uid, ...item }
                state.formData.image_ids = []
                state.imgPreviewList = []

                state.formData.images.map((item:ImgItemInt) => {
                    if (item.id) {
                        // @ts-ignore
                        state.formData.image_ids.push(item.id)
                        // @ts-ignore
                        state.imgPreviewList.push(item.url)
                    }
                })
            } else {
                let fitItemIndex = state.formData.content_images.findIndex((item:ImgItemInt) => item.uid == uid)
                // @ts-ignore
                state.formData.content_images[fitItemIndex] = { uid, ...item }
                state.formData.content_img_ids = []
                state.contentImgPreviewList = []
                state.formData.content_images.map((item:ImgItemInt) => {
                    if (item.id) {
                        // @ts-ignore
                        state.formData.content_img_ids.push(item.id)
                        // @ts-ignore
                        state.contentImgPreviewList.push(item.url)
                    }
                })
            }
        },
        // 获取规格详细信息
        editSpec: (row, index) => {
            state.specOptions   = {...row}  // 规格回显数据
            state.specDialog    = true      // 显示规格弹框
            state.currSpecIndex = index     // 设置当前操作规格索引值
        },
        // 获取收费附件详细信息
        editCharge: (row, index) => {
            state.chargeOptions   = {...row}  // 规格回显数据
            state.chargeDialog    = true      // 显示规格弹框
            state.currChargeIndex = index     // 设置当前操作规格索引值
        }
    })
    const mainPreviewList = computed(() => {
        const { images } = state.formData
        let tmpArr = images.map(item => {
            // @ts-ignore
            if (item.id) {
                // @ts-ignore
                return (item.url.replace('?x-oss-process=style/s_img_160', '')).replace('_s.jpg', '.jpg')
            }
        })
        return tmpArr
    })

    const maxPreSaleDate = Date.now() + 1000*60*60*24*30 // 预售时间为 30 天内
    const disabledPreSaleDate = (date) => { // 返回不可用日期
        return date.getTime() < Date.now() || date.getTime() > maxPreSaleDate
    }
    // 获取二级品牌列表
    const getSecondBrandList = (brand_id:string) => {
        proxy.$http.get('/admin/shop_product/getSbrandList?bid=' + brand_id).then(res => {
            const {code, data:resData, msg} = res
            if (code != 200) {
                return proxy.$message({
                    type: 'error',
                    message: msg
                })
            }

            state.secondBrandList = resData
        })
    }
    // 获取品牌关联城市
    const getCityList = () =>{
        proxy.$http.post(`/admin/shop_product/getCityListByBrandId?brand_id=${state.formData.brand_id}`).then((res:any) => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            state.cityList = data

            // 组合全部城市ID集合，计算城市个数，供全选功能使用
            let cityListLen = 0
            let cityIds = []
            data.map(item => {
                const { options } = item
                cityListLen += options.length
                options.map(subItem => {
                    // @ts-ignore
                    cityIds.push(subItem.id)
                })
            })
            state.cityListLen = cityListLen
            state.cityIds = cityIds
        })
    }
    //获取标签列表
    const getTagsGroup = () => {
        const { shop_product_id } = state
        const { cat_id } = state.formData
        if (cat_id) {
            proxy.$http.post(`/admin/shop_product/getTagsGroup?${joinParams({shop_prodcut_id:shop_product_id, cat_id})}`).then(res => {
                const { code, data, msg } = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                state.tagList = data
            })
        }
    }
    // 城市全选按钮状态监听
    const onIsSelectedAllChange = (val) => {
        if (val) {
            state.formData.city_ids = state.cityIds
        } else {
            state.formData.city_ids = []
        }
    }
    // 验证蛋糕品牌-原料必填
    const validMaterial = (rule:any, val:any, callback:any) => {
        const { cat_id, extra_data } = state.formData
        if (cat_id==`${BrandCat['蛋糕']}` && extra_data.material=='') {
            callback(new Error('请输入原料'))
        } else {
            callback()
        }
    }
    // 验证发票和税点：当发票类型为专票或普票时，税点必填；当税点填写时发票类型必选
    const validInvoiceType = (rule:any, val:any, callback:any) => {
        const { invoice_type, tax_Point } = state.formData
        if (!invoice_type && tax_Point) {
            callback(new Error('请选择发票类型'))
        } else {
            callback()
        }
    }
    const validTaxPoint = (rule:any, val:any, callback:any) => {
        const { invoice_type, tax_Point } = state.formData
        if ((InvoiceType[invoice_type]=='专票'|| InvoiceType[invoice_type]=='普票') && !tax_Point) {
            callback(new Error('请输入税点'))
        } else {
            callback()
        }
    }
    // 规格表单，市场价不能小于售价验证
    const validPrice = (rule:any, val:any, callback:any) => {
        const { market_price, price } = state.specOptions
        if (market_price && price && Number(market_price) < Number(price)) {
            let errorMsg = rule.field === 'price' ? '售价不能大于市场价' : '市场价不能于小售价'
            callback(new Error(errorMsg))
        } else {
            callback()
        }
    }
    // 商品表单验证规则
    const productRules = reactive({
        brand_id: [
            { required: true, type: 'number', message: '请选择品牌', trigger: 'blur' }
        ],
        cat_id: [
            { required: true, message: '请选择品类', trigger: 'blur' }
        ],
        is_pre_sale: [
            { required: true, message: '请选择是否为预售商品', trigger: 'blur' }
        ],
        pre_sale_date: [
            { required: true, message: '请选择预售时间', trigger: 'change' }
        ],
        title: [
            { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        description: [
            { required: true, message: '请输入商品介绍', trigger: 'blur' }
        ],
        extra_data: {
            material: [
                { validator: validMaterial, trigger: 'blur' }
            ],
            storage: [
                { required: true, message: '请输入储存条件', trigger: 'blur' }
            ],
            distribution: [
                { required: true, message: '请输入配送范围', trigger: 'blur' }
            ]
        },
        is_greeting: [
            { required: true, message: '请选择是否支持祝福语配置', trigger: 'blur' }
        ],
        label_name: [
            { required: true, message: '请选择至少一种商品标签', trigger: 'blur' }
        ],
        is_time: [
            { required: true, message: '请选择是否需要定时审核', trigger: 'blur' }
        ],
        examine_time: [
            { required: Boolean(state.formData.is_time), message: '请选择定时审核时间', trigger: 'blur' }
        ],
        invoice_type: [
            { validator: validInvoiceType, trigger: 'change' }
        ],
        tax_Point: [
            { validator: validTaxPoint, trigger: 'blur' }
        ]
    })
    // 规格编辑表单验证规则
    const specRules = reactive({
        name: [
            { required: true, message: '请填写规格名称', trigger: 'blur' }
        ],
        market_price: [
            { required: true, message: '请填写市场价', trigger: 'blur' },
            { validator: validPrice, trigger: 'blur' }
        ],
        clearing_price: [
            { required: true, message: '请填写结算价', trigger: 'blur' }
        ],
        shop_discount: [
            { required: true, message: '请填写折扣', trigger: 'blur' }
        ],
        price: [
            { required: true, message: '请填写售价', trigger: 'blur' },
            { validator: validPrice, trigger: 'blur' }
        ]
    })
    // 收费附件表单验证规则
    const chargeRules = reactive({
        name: [
            { required: true, message: '请填写附件名称', trigger: 'blur' }
        ],
        unity: [
            { required: true, message: '请填写单位', trigger: 'blur' }
        ],
        price: [
            { required: true, message: '请填写单价', trigger: 'blur' }
        ],
        limit: [
            { required: true, message: '请填写限制数量', trigger: 'blur' }
        ],
        status: [
            { required: true, message: '请选择状态', trigger: 'change' }
        ],
        type: [
            { required: true, message: '请选择类型', trigger: 'change' }
        ],
    })
    const hourList = ['00:00:00', '01:00:00', '02:00:00', '03:00:00', '04:00:00', '05:00:00', '06:00:00', '07:00:00', '08:00:00', '09:00:00', '10:00:00', '11:00:00', '12:00:00', '13:00:00', '14:00:00', '15:00:00', '16:00:00', '17:00:00', '18:00:00', '19:00:00', '20:00:00', '21:00:00', '22:00:00', '23:00:00', '24:00:00']

    // 当前选中品类发生变化,重新获取当前品类所属的标签列表
    watch(() => state.formData.cat_id, (newVal, oldVal) => {
        getTagsGroup()
    })
    // 当前品牌发生变化,重新获取当前品牌开通的城市，同时清空二级品牌数据
    watch(() => state.formData.brand_id, (newVal, oldVal) => {
        getCityList()
        if (oldVal != '') {
            state.formData.sbrand_id = ''
            state.formData.sbrand_name = ''
        }
    })
    // 当前品牌的品类发生变化,重新获取二级品牌列表
    watch(() => state.formData.brand_cat_id, (newVal, oldVal) => {
        if (state.formData.brand_cat_id === BrandCat['零食']) {
            getSecondBrandList(state.formData.brand_id)
        }
    })
    // 监听规格结算价和售价变化，动态计算结算折扣
    watch(() => [state.specOptions.clearing_price, state.specOptions.price], (newVal, oldVal) => {
        const clearing_price = newVal[0]
        const price = newVal[1]
        if (clearing_price && price) {
            // @ts-ignore
            state.specOptions.shop_discount = (Math.round(clearing_price / price * 1000) / 10).toFixed(2)
        } else {
            state.specOptions.shop_discount = ''
        }
    })
    // 监听选中城市变化，修改全选按钮状态
    watch(() => state.formData.city_ids, (newVal, oldVal) => {
        let len = newVal.length
        if (len === 0) {
            state.isSelectedAll = false
            state.isIndeterminate = false
        } else if (len === state.cityListLen) {
            state.isSelectedAll = true
            state.isIndeterminate = false
        } else {
            state.isIndeterminate = true
        }
    })

    state.getBrandList()
    state.getProductInfo()

    return { ...toRefs(state), productRules, specRules, chargeRules, disabledPreSaleDate, BrandCat, CheckStatus, InvoiceType, router, hourList, mainPreviewList, onIsSelectedAllChange }
}
})
